import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const DriverBehaviorPage = lazy(() => import('@cobliteam/driver-behavior'));

const routes = [
  {
    path: Location.DRIVER_BEHAVIOR,
    component: DriverBehaviorPage,
    accessDeniedDescription: 'ver dados de modo de condução de motoristas',
  },
];

export default routes;
